import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

// Named sections remain stable even when visible tab labels or ordering change.
export function useCrmTab(names){
  const [params,setParams]=useSearchParams();
  const index=Math.max(0,names.indexOf(params.get('tab')));
  const setTab=value=>setParams(current=>{const next=new URLSearchParams(current);next.set('tab',names[value]||names[0]);next.delete('record');return next;});
  return [index,setTab];
}
export function useCrmFocus(key,ready){
  useEffect(()=>{
    if(!ready||!key)return;
    const target=document.getElementById(key);
    if(!target)return;
    target.scrollIntoView?.({block:'center',behavior:'auto'});
    target.focus({preventScroll:true});
  },[key,ready]);
}
